export default {
  en: {
    HEADER_PREDICTIVE_ROUTING: 'Predictive Routing',
    BUTTON_CREATE_PREDICTIVE_ROUTING: 'Create Configuration',
    SEARCH_PREDICTIVE_ROUTING: 'Search Configurations',
    PREDICTIVE_ROUTING_EMPTY: 'You have not created any configurations.',

    TABLE_COL_NAME: 'Name',
    TABLE_COL_TYPE: 'Type',
    PREDICTIVE_ROUTING_TABLE_LOADING: 'Loading Predictive Routing',
    TYPE_REVENUE: 'Use Revenue',

    MESSAGE_CREATE_SUCCESS: 'Predictive Routing Configuration Created',
    MESSAGE_UPDATE_SUCCESS: 'Predictive Routing Configuration Updated',
    MESSAGE_DELETE_SUCCESS: 'Predictive Routing Configuration Deleted',

    ERPC_REFERENCES_LOADING: 'Loading References',
    ERPC_REFERENCES_EMPTY: 'This configuration does not have any references.',
    RPC_PREDICTIVE_ROUTING_SHOW_ALL: 'Show all Predictive Routing',

    DELETE_PREDICTIVE_ROUTING_CONFIG_CONFIRMATION_TITLE: 'Delete Predictive Routing Configuration',
    DELETE_PREDICTIVE_ROUTING_CONFIG_MODAL_TEXT: 'Are you sure you want to delete {predictiveRoutingConfigToDeleteName}?',
    DELETE_PREDICTIVE_ROUTING_CONFIG_MODAL_CHECK_ASSOCIATION_ERROR_TEXT: 'An error occurred while determining associated entities, please try again.',
    DELETE_PREDICTIVE_ROUTING_CONFIG_ATTEST: 'I understand that deleting this Predictive Routing Configuration will activate the parent settings for the entities above. If other settings are not available, Predictive Routing will be disabled.',
    DELETE_PREDICTIVE_ROUTING_CONFIG_ATTEST_NONE: 'I understand that deleting this Predictive Routing Configuration will remove it from attached entities. If other settings are not available, Predictive Routing will be disabled.'
  }
};